import { componentSizeMap } from '@bigin/constants'

import type { ComponentSize } from '@bigin/constants'

export const getComponentSize = (size?: ComponentSize) => {
  return componentSizeMap[size || 'default']
}
